var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ve-table',{attrs:{"api-mode":false,"columns":_vm.columns,"table-data":_vm.dayBookEntries,"row-key-field-name":"DBIdent","expand-option":_vm.expandOption,"width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }